import React, {useContext, useState} from 'react';
import Icon from '../../../assets/icons/icon';
import InviteSearch from './inviteSearch';
import { AgentContext } from '../../../context/AgentContext';
import { useSelector } from 'react-redux';

function Invite({members,setInvitePopup, title, teamId}) {

    // console.log(teamId)
    const {isB2B} = useContext(AgentContext)
    const colorData = useSelector(state => state.colorData)
    return (
        <div className="invitePopup">
            <div className="inviteContent">
                <div className="quilityCloseWindow" onClick={()=>setInvitePopup(false)}><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span></div>
                <div className="quilityParentBlockHeader quilityParentBlockTitle" style={{backgroundColor:'unset'}}>Manage Members for {title}</div>
                <div className="invitePopupContent">
                    <InviteSearch members={members} setInvitePopup={setInvitePopup} teamId={teamId}/>
                </div>
            </div>
        </div>
    );
}

export default Invite;
